import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/touxiang.jpg'


const _withScopeId = n => (_pushScopeId("data-v-ce521510"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topBar" }
const _hoisted_2 = { class: "topBar_right" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "topBar_open_avatar",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBar_open_name" }, "昵称", -1))
const _hoisted_6 = { class: "topBar_open_my" }
const _hoisted_7 = { class: "topBar_box" }

import { ref, withDefaults } from 'vue';
import { RightOutlined } from '@ant-design/icons-vue';

interface Props {
  component: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  props: {
    component: { default: Object }
  },
  setup(__props: any) {

const props = __props as { component: any };



const open = ref(false);
const openTopbar = () => {
  open.value = !open.value;
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_svg_icon, {
      "icon-class": "more",
      onClick: openTopbar
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_svg_icon, { "icon-class": "collect" }),
      _createTextVNode(),
      _hoisted_3
    ]),
    _createElementVNode("div", {
      class: "topBar_open",
      style: _normalizeStyle({ display: open.value ? 'block' : 'none' })
    }, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createVNode(_component_svg_icon, { "icon-class": "gateway_collect" }),
          _createTextVNode("我的收藏")
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_svg_icon, { "icon-class": "attention" }),
          _createTextVNode("我的关注")
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.titleList, (item, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: index,
            class: "topBar_open_list"
          }, [
            _createElementVNode("div", null, _toDisplayString(item.title), 1),
            _createVNode(_unref(RightOutlined), { class: "svg" })
          ])), [
            [_vShow, item.title]
          ])
        }), 128))
      ])
    ], 4)
  ]))
}
}

})